import React, { useState } from 'react';
import { Page } from '../components/ContentBlocks';

const LayoutContext = React.createContext(null);

interface ProviderProps {
  children: JSX.Element | JSX.Element[];
}
export const LayoutStateProvider = (props: ProviderProps) => {
  const { children } = props;
  const selectedNav = useState<Page>(null);
  const subNavScrollPos = useState(null);

  return (
    <LayoutContext.Provider value={{ selectedNav, subNavScrollPos }}>
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayoutState = () => React.useContext(LayoutContext);
